import $ from 'jquery';

(function (root, $, undefined) {

  "use strict";

  $(function () {

    var sliders = [];

    $.fn.isInViewport = function (offset) {
      if(!offset) {
        offset = 0;
      }
      var elementTop = $(this).offset().top + offset;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      return elementBottom > viewportTop && elementTop < viewportBottom;
    };
    
    $(function() { 
      is_mobile();

      // thisLazyLoad();
      document.addEventListener("scroll", thisLazyLoad);
      window.addEventListener("resize", thisLazyLoad);
      window.addEventListener("orientationchange", thisLazyLoad);

      document.addEventListener("wpcf7submit", function(){
        setTimeout(() => {
          reVerifyCheckbox();
        }, 500);
      });

      var ua = navigator.userAgent.toLowerCase();
      var isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");
      if(isAndroid) {
        document.body.className += ' is_android'; 
      }

      setCommon();
      menu_listener();
      detect_touch();
      // checkFormFiels();

      checkScrollClass();
      
      initSwiper();
      initLightCase();

    });

    $(window).on('load', function(){
      manageAccordion();
    });
      
    $(window).on('resize', function(){
      if (this.resizeTO) clearTimeout(this.resizeTO);
      this.resizeTO = setTimeout(function () {
          $(this).trigger('resizeEnd');
      }, 300);
    });

    $(window).on('resizeEnd', function() {
      manageAccordion();
      checkScrollClass();
    });


    $(document).ajaxComplete(function(){
      reVerifyCheckbox();
      thisLazyLoad();
    });

    function manageAccordion() {
      $('.single_modello').each(function(){
        var submenu = $(this);
        var vw = $(window).width();
        submenu.css('max-height',submenu[0].scrollHeight + 40 + (vw / 100 * 4));
      });

      $('.accordion_content').each(function(){
        var submenu = $(this);        
        // console.log(submenu[0].scrollHeight);
        submenu.css('max-height',submenu[0].scrollHeight + 60);
      });
    } 

    function setCommon() {

      $('a[data-rel^=goto]').on('click',function(){
        var this_link = $(this);
        var attrs = this_link.data('goto');
        if(attrs != null && attrs != "") {
          var res = attrs.split(',');
          var offset = typeof res[1] !== "undefined" ? parseInt(res[1]) : null;
          var velocity = typeof res[2] !== "undefined" ? parseInt(res[2]) : 2000;
          thisGoTo(res[0], offset, velocity, res[3]);
        }
      });

      $('body').on('click','.scrollDown',function(e){
        if($('.section_1').length > 0){
          thisGoTo('.section_1',-80);
        }
      });

      $('.woocommerce-form__label-for-checkbox').addClass('checkbox');

      $('body').on('click','label.checkbox',function(){
        if($(this).closest('.woocommerce-checkout').length > 0 || $(this).closest('.woocommerce-form-login').length > 0) {
          label_checkbox_toggle($(this));
        } else {
          label_checkbox_toggle($(this).find('.wpcf7-list-item'));
        }
      });

      // fix lazy-loading images in a lower point while rendering swipers
      setTimeout(function(){
        thisLazyLoad();
      }, 200);

      $('body').on('mouseover','.arco_page',function(){
        checkHoverImage(this);
      });

      // Add specific function for #banner_home_video
      if ($('#banner_home_video').length > 0) {
        handleBannerHomeVideo();
      }
      
    }

    function checkHoverImage(elem) {
      var imgs = [].slice.call(elem.getElementsByClassName('hover_img'));
        
      imgs.forEach(function (img) {
        if(!img.classList.contains('img_loaded')){
          if(img.dataset.srchover !== undefined)
            img.src = img.dataset.srchover;

          img.classList.add("img_loaded");              
        }
      });
    }

    function linkVideoSource(video) {
      if(video.hasClass('lazy')) {
        var source = video.find('source');
        var src = source.data('src');
        source.attr('src',src);
        video[0].load();
        video.removeClass('lazy');
      }
    }

    function handleBannerHomeVideo() {
      // Add code specific to #banner_home_video
      var videoBanner = $('#banner_home_video');

      // Play video on scroll into view
      $(window).on('scroll mousemove', function() {
        if (videoBanner.isInViewport()) {
          linkVideoSource(videoBanner);
          videoBanner[0].play();
        } else {
          videoBanner[0].pause();
        }
      });

      // Ensure the video is controlled correctly on resize
      $(window).on('resize', function() {
        if (videoBanner.isInViewport()) {
          linkVideoSource(videoBanner);
          videoBanner[0].play();
        } else {
          videoBanner[0].pause();
        }
      });

    }

    function reVerifyCheckbox() {
      $('input[type=checkbox]').each(function(){
        var el = $(this).closest('.checkbox');

        if(el.closest('.woocommerce-checkout').length > 0 || el.closest('.woocommerce-form-login').length > 0) {
          label_checkbox_toggle(el);
        } else {
          label_checkbox_toggle(el.find('.wpcf7-list-item'));
        }
      });
    }

    function label_checkbox_toggle($label) {
      var $parent = $label;
      var $el = $label.find('input[type="checkbox"]');
      if($el.is(':checked')){
          $parent.addClass('checked');
      } else {
          $parent.removeClass('checked');
      }
    }

    function checkScrollClass() {
      $(window).on('load scroll', function(){ scrolledClass() });
    } 

    var last_wh;
    const scrolledClass = function () {
      
      if($('.initial_banner').length > 0) {
        var wh = $('.initial_banner')[0].scrollHeight - 100; 
      } else {
        var wh = $(window).height() / 3;
      }
  
      if ($(window).scrollTop() >= (wh)) {
        if (!$('body').hasClass('scrolled'))
          $('body').addClass('scrolled');
      } else {
        if ($('body').hasClass('scrolled'))
          $('body').removeClass('scrolled');
      }
    }


    const initSwiper = () => {
      if ($(".swiper").length > 0) {
        import("swiper/swiper.min.css");
        import("swiper/css/pagination");
        import("swiper/css/navigation");
        import("swiper/css/effect-fade");
        import("swiper")
          .then((module) => {
            module.Swiper.use([
              module.Autoplay,
              module.Navigation,
              module.EffectFade,
              module.Pagination,
              module.Lazy
            ]);
  
            $(".swiper").each((index, item) => {
              const data = $(item).data("slideshow");
              // console.log(data);
  
              // console.log("data", data);
              if (data && data.pagination && !data.pagination.type) {
                data.pagination.renderBullet = (index, className) => {
                  return '<span class="' + className + '"></span>';
                };
              }
              if (data && data.pagination && data.pagination.type == 'fraction') {
                data.pagination.renderFraction = (currentClass, totalClass) => {
                  return '<span class="' + currentClass + '"></span><span class="' + totalClass + '"></span>';
                };
                data.pagination.formatFractionCurrent = (currentNumber) => {
                  return ('0' + currentNumber).slice(-2);
                }
                data.pagination.formatFractionTotal = (totalNumber) => {
                  return ('0' + totalNumber).slice(-2);
                }
              }
  
              if (data && !data.disabled) {
                const slider = new module.Swiper(item, {
                  ...data
                });
                sliders.push(slider);
              } else {
                $(item).find(".swiper-button-next").hide();
                $(item).find(".swiper-button-prev").hide();
                $(item).find(".swiper-pagination").hide();
              }
            });
          })
          .catch((e) => {
            console.log("Error loading swiper: ", e);
          });
      }
    };


    const initLightCase = () => {
      if ($('.lightcase').length > 0) {
        $('.lightcase').each(function(){
          $(this).attr('data-rel','lightcase');
        });
      }
      if ($("a[data-rel^=lightcase]").length > 0) {
        import("lightcase/src/css/lightcase.css");
        import("lightcase/src/js/lightcase.js").then(() => {
          
            $("a[data-rel^=lightcase]").lightcase({
              maxHeight: 1280,
              maxWidth: 1920,
              video: {
                autoplay: true,
                width: "1280px",
                height: "720px",
              },
              iframe: {
                width: "1280px",
                height: "720px",
              }
            });
            
        });
      }
    };
    

    function menu_listener(){

      $('a[href="#"]').on('click',function(e){
          e.preventDefault();
      });

      $('a[href="#form"]').on('click',function(e){
          e.preventDefault();
          thisGoTo('.footer_form',-50);
      });

      $('a[href="#newsletter"]').on('click',function(e){
          e.preventDefault();
          $('body').addClass('form_open');
      });

      $('body').on('click',function(e){
        if($(e.target).is('body') && $(e.target).hasClass('menu_open')){
          $('body').removeClass('menu_open');
        }
        if($(e.target).is('body') && $(e.target).hasClass('form_open')){
          $('body').removeClass('form_open');
        }
      });
      
      $('body').on('click','.close_menu', function(){
        $('body').removeClass('menu_open');
      });
      $('body').on('click','.close_popup', function(){
        $('body').removeClass('form_open');
      });

      $('body').on('click','.scrolldown', function(){
        var next = $(this).closest('section').next();
        // console.log(next);
        thisGoTo(next, -40);
      });

      $('#nav-button').on('click', function(){
        if(!$('body').hasClass('menu_open')) {
            $('body').addClass('menu_open');
        } else {
            $('body').removeClass('menu_open');
        }
      });

    }

    function thisLazyLoad() {
      if(typeof lazyLoad === "function"){
        lazyLoad();
      }
    }

    function thisGoTo(target, offset, velocity, ease) {
      if(typeof goTo === "function"){
        goTo(target, offset, velocity, ease);
      }
    }

    // function checkFormFiels() {

    //   var label, container;
    //   $('.wpcf7-form p').each(function(index,item){
    //       label = $(item).find('span.spanlabel'); //.detach(); 
    //       container = $(item).find('.wpcf7-form-control-wrap');
    //       label.appendTo(container);
    //   });

    //   var $wpcf_fields = $('.wpcf7-form-control-wrap input[type!="checkbox"], .wpcf7-form-control-wrap textarea');
    //   $wpcf_fields.each(function(){
    //       var $el = $(this);
          
    //       $el.on('load change click focusout paste autocomplete', function(){
    //           //console.log($(this).val());
    //           if($el.val() != ""){
    //               $el.closest('.wpcf7-form-control-wrap').find('input').addClass('filled');
    //               $el.closest('.wpcf7-form-control-wrap').find('textarea').addClass('filled');
    //           } else {
    //               $el.closest('.wpcf7-form-control-wrap').find('input').removeClass('filled');
    //               $el.closest('.wpcf7-form-control-wrap').find('textarea').removeClass('filled');
    //           }
    //       });
    //   });

    // }

  });


  var isMobile = false;
  function is_mobile(){
      if((/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase()))){
          isMobile = true;
      } else {
          isMobile = false;
      }
  }

  function detect_touch(){
    if("ontouchstart" in window){
      document.documentElement.className = document.documentElement.className + " touch";
    } else {
      document.documentElement.className = document.documentElement.className + " no_touch";
    }
  }

}(this, $));
